module.exports = __webpack_public_path__ + "img/elastic width.ae818a62.png";